import actions from './actions';
import mutations from './mutations';
import state from './initialState';

const otp = {
  namespaced: true,

  state,

  mutations,

  actions,
};

export default otp;
